import { render, staticRenderFns } from "./BaseDetailsView.vue?vue&type=template&id=27408594&scoped=true&"
import script from "./BaseDetailsView.vue?vue&type=script&lang=js&"
export * from "./BaseDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./BaseDetailsView.vue?vue&type=style&index=0&id=27408594&prod&lang=scss&scoped=true&"
import style1 from "./BaseDetailsView.vue?vue&type=style&index=1&id=27408594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27408594",
  null
  
)

export default component.exports